import React, { useCallback } from "react";

import { FormRadioSelect } from "../../../forms/FormRadioSelect";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews.interfaces";
import { useAppSelector, useDispatchers } from "../../reducers";
import { Dispatchers } from "../dispatchers";
import { getWriteReviewFormState } from "../selectors";

interface IOwnProps {
    formUUID: IFormUUID;
    name: string;
    field: IWriteReviewTemplateField;
}

export const WriteReviewFormRadioField = (
    props: IOwnProps,
): React.ReactNode => {
    const dispatchers = useDispatchers(Dispatchers);

    const formState = useAppSelector((rootState) =>
        getWriteReviewFormState(rootState.reviews, props),
    );

    const value = formState?.valuesText[props.name] ?? "";
    const errors = formState.errors[props.name] ?? [];
    const showErrors = formState.showErrors;

    const onChange = useCallback(
        (e: React.FormEvent<HTMLInputElement>) => {
            dispatchers.onReviewFormRadioChange({
                formUUID: props.formUUID,
                fieldName: props.name,
                fieldValue: e.currentTarget.value,
                isChecked: e.currentTarget.checked,
            });
        },
        [dispatchers, props.formUUID, props.name],
    );

    const choices = props.field.options.map((option) => {
        return {
            value: option,
            label: option,
        };
    });

    return (
        <FormRadioSelect
            name={`${props.name}-${props.formUUID}`}
            id={`${props.name}-${props.formUUID}`}
            required={props.field.is_required}
            label={props.field.name}
            labelPlacement={"static"}
            legend="Recommendations"
            choices={choices}
            onChange={onChange}
            value={value}
            errors={errors}
            showErrorMessages={showErrors}
        />
    );
};
